// extracted by mini-css-extract-plugin
export default {"anonymousHeader":"AnonymousLayout_anonymousHeader__pcR-g","content":"AnonymousLayout_content__YbNsI","anonymousLayout":"AnonymousLayout_anonymousLayout__MWrpS"};